import React from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { format } from "date-fns";
import GlobalVariable from "../../../../services/globalVar";

const PaymentsReceived = (props) => {
    const parentDatas = props;

    const dateBodyTemplate = (rowData) => {
        return (
          <div>
            {format(
              new Date(rowData.paymentDate),
              GlobalVariable.userDet.tenantConfig.dateFormat
            )}
          </div>
        );
      };

  return (
    <div className="card">
            <DataTable value={parentDatas.paymentReceved} tableStyle={{ minWidth: '100%' }}>
                <Column field="dateBodyTemplate" header="Payment Date" body={dateBodyTemplate}></Column>
                <Column field="paymentCode" header="Payment Code"></Column>
                <Column field="companyName" header="Company Name"></Column>
                <Column field="customername" header="Customer Name" body={(a) => a.firstName + " " + a.lastName} ></Column>
                <Column field="paymentMode" header="Payment Mode"></Column>
                <Column field="mount" header="Amount" className="text-end amount-align" body={(a) => parentDatas.currency + " " + a.amount.toFixed(2)}></Column>
            </DataTable>
        </div>
  )
}

export default PaymentsReceived